import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useGetSasToken = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("storage/sas");
    }, {
        ...options,
        onSuccess: (data: any, variables: any, context: any) => {
            // Silently skip when Azure Blob Storage is not configured (local dev)
            if (data?.statusCode === 200 && data?.data) {
                options?.onSuccess?.(data, variables, context);
            }
        }
    });
}